import axios from '../plugins/axios';

// Remove '/api' from the base URLs since it's already in axios.defaults.baseURL
const API_URL = '/admin/users';
const ROLES_API_URL = '/admin/roles';

export default {
  async getUsers(filters = {}) {
    let url = API_URL;
    
    if (filters.name) {
      // Manually construct the query string to avoid URL encoding of brackets
      url += `?_filters_[]=name__contains&name__contains=${encodeURIComponent(filters.name)}`;
    }
    
    console.log('API Request URL:', url); // Debug log
    
    try {
      const response = await axios.get(url);
      console.log('API Response:', response.data); // Debug log
      return response.data;
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    }
  },
  
  async addUser(user) {
    const response = await axios.post(API_URL, user);
    return response.data;
  },
  async updateUser(userId, user) {
    const response = await axios.put(`${API_URL}/${userId}`, user);
    return response.data;
  },
  async getRoles() {
    try {
      const response = await axios.get(ROLES_API_URL);
      console.log('API Response for roles:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching roles:', error);
      throw error;
    }
  }
};
